import { TblSortDir } from '../table.types';

export function sortTextFn(col: string, dir: TblSortDir): (a: any, b: any) => number {
    return (a, b) => {
        const aVal = a[col] == null ? '' : `${a[col]}`;
        const bVal = b[col] == null ? '' : `${b[col]}`;
        return dir === 'DSC' ? bVal.localeCompare(aVal) : aVal.localeCompare(bVal);
    };
}
